import {Command} from './Command';
import {SetHeightAction} from '../actions';
import {DeckHeightService} from '../../deck-height.service';

export class SetHeightCommand extends Command<SetHeightAction> {

  private oldState: {
    oldHeight: number,
    oldWallScale: number
  };

  constructor(
    private deckHeightSrvc: DeckHeightService
  ) {
    super();
  }

  do(action: SetHeightAction): void {
    this.oldState = this.deckHeightSrvc.setDeckHeightNoSubjectUpdate(action.height, action.wallScale);
  }

  undo(): void {
    const {oldHeight, oldWallScale} = this.oldState;
    this.deckHeightSrvc.setDeckHeightNoSubjectUpdate(oldHeight, oldWallScale);
    this.deckHeightSrvc.setDeckHeight(oldHeight);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/SetHeightCommand.ts